import { render, staticRenderFns } from "./VCompanyServices.vue?vue&type=template&id=b7a36aa0&scoped=true&lang=pug"
import script from "./VCompanyServices.vue?vue&type=script&lang=ts"
export * from "./VCompanyServices.vue?vue&type=script&lang=ts"
import style0 from "./VCompanyServices.vue?vue&type=style&index=0&id=b7a36aa0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a36aa0",
  null
  
)

/* custom blocks */
import block0 from "./CompanyServices.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fpages%2FLayout%2Fviews%2FExpert%2Fviews%2FCompanies%2Ftemplate%2Fviews%2FServices%2FVCompanyServices.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports